import * as React from 'react';
import {
  CHATS_PAGE,
  COACH_HOME_PAGE,
  HOME_PAGE_REWRITE,
  MY_COACH_PLAYERS_PAGE,
  MY_SCHEDULE_PAGE,
} from 'constants/pages';
import PlusWithoutBG from 'svg/PlusWithoutBG';
import { Button } from 'components/Button';
import NavLink from './NavLink';

interface Props {
  currentPath: string;
  currentPathname: string;
  isInvert?: boolean;
  onOpenEventTypeModal: () => void;
  onNavigate: (href: string) => void;
}

export default function CoachNavLinks({
  currentPath,
  currentPathname,
  isInvert,
  onOpenEventTypeModal,
  onNavigate,
}: Props) {
  const isHomeActive = currentPath === COACH_HOME_PAGE || currentPath.startsWith(HOME_PAGE_REWRITE);
  const isScheduleActive = currentPathname === MY_SCHEDULE_PAGE;
  const isClientsActive = currentPath === MY_COACH_PLAYERS_PAGE;
  const isChatActive = currentPath === CHATS_PAGE;

  return (
    <div className="mx-3 hidden h-full items-center xs:gap-0 md:flex lg:gap-6">
      <NavLink
        href={COACH_HOME_PAGE}
        isActive={isHomeActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        Home
      </NavLink>
      <NavLink
        href={MY_SCHEDULE_PAGE}
        isActive={isScheduleActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        Calendar
      </NavLink>
      <div className="px-ds-lg py-2">
        <Button
          variant="brand"
          className="flex h-10 w-10 shrink-0 grow-0 rounded-full border-none px-2.5 shadow-lg focus:outline-none lg:w-10"
          onClick={onOpenEventTypeModal}
          isInline
          size="icon"
          iconLeft={<PlusWithoutBG className="h-6 w-6 cursor-pointer" />}
        />
      </div>
      <NavLink
        href={MY_COACH_PLAYERS_PAGE}
        isActive={isClientsActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        Clients
      </NavLink>
      <NavLink
        href={CHATS_PAGE}
        isActive={isChatActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        Chat
      </NavLink>
    </div>
  );
}
